import React, { useState, useEffect } from 'react'
import useModal from 'hook/useModal'

// css
import 'assets/style/elements/tag.scss'

function Element({ children, color = 'green', text, className, data = [] }) {
  return (
    <div className={'tags ' + className}>
      {data && data.length > 0 ? (
        data.map((item, index) => (
          <span key={`tag_${index}`} className={`tag ${item.color}`}>
            {item.text}
          </span>
        ))
      ) : (
        <span className={`tag`}>&nbsp;</span>
      )}
    </div>
  )
}

export default Element
